<div class="nav-bar">
  <app-navbar  (collapsedChange)="isCollapsed = $event"></app-navbar>
</div>

    <app-sidepannel [collapsed]="isCollapsed" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"></app-sidepannel>
    
    <div [class.body]="!isCollapsed" [class.body-trimmed]="isCollapsed  ">
      <router-outlet></router-outlet>
    </div>
      <!-- <div class="content" >
        <div class="container-fluid">
        <div class="card bottom" *ngIf="isShown">
        
        <div class="card-body">
        <div class="d-flex">
        <button class="left1"  mat-raised-button   (click)="ZincDB();">
          <span>Synchronize DB</span>
      </button>
    </div>
  <div *ngIf=loaderShown class="loader"></div>
  <div class="alert alert-success alert-dismissible alertWidth" *ngIf="Notification">
  
  <h4><i class="icon fas fa-check"></i> {{Message}}</h4>
       
    </div>   
       </div>
        </div>
        </div>
        </div> -->
